import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';
import FontAwesome from 'react-fontawesome';
import * as shortid from "shortid";
import { tooltipTexts } from '../../../utils/tooltipTexts';
import _ from 'lodash';

export class TooltipIcon extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tooltipOpen: false,
            id: shortid.generate()
        };
    }

    toggle = () => this.setState({ tooltipOpen: !this.state.tooltipOpen });

    render() {
        const text = _.get(tooltipTexts, this.props.textKey, 'Texto do tooltip não encontrado.');

        return (
            <span style={{ marginLeft: '8px', color: '#6c757d' }}>
                <FontAwesome name="question-circle" id={`tooltip-${this.state.id}`} />
                <Tooltip placement="top" isOpen={this.state.tooltipOpen} target={`tooltip-${this.state.id}`} toggle={this.toggle}>{text}</Tooltip>
            </span>
        );
    }
}